import { render, staticRenderFns } from "./Resumo.vue?vue&type=template&id=931d8d56&scoped=true"
import script from "./Resumo.vue?vue&type=script&lang=js"
export * from "./Resumo.vue?vue&type=script&lang=js"
import style0 from "@/components/regras/regra-resumo.css?vue&type=style&index=0&id=931d8d56&prod&scoped=true&lang=css&external"
import style1 from "./Resumo.vue?vue&type=style&index=1&id=931d8d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931d8d56",
  null
  
)

export default component.exports